export default "__VITE_ASSET__Bi$RojzU__"